import { render, staticRenderFns } from "./OuterClick.vue?vue&type=template&id=0d78d15a&"
import script from "./OuterClick.vue?vue&type=script&lang=js&"
export * from "./OuterClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports